import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-text-toggle',
  templateUrl: './text-toggle.component.html',
})
export class TextToggleComponent {
  @Input() public description: string;
  @Input() public isOpen = false;
  @Input() public maxCharacters: number;

  constructor(private readonly translateService: TranslateService) {}

  public seeMore(): void {
    this.isOpen = !this.isOpen;
  }

  public get isShortDescription(): boolean {
    return this.description.length <= this.maxCharacters;
  }

  public get seeButtonTranslation(): string {
    return this.isOpen
      ? this.translateService.instant(
          'attendee.activity_page.organizer_description.showless'
        )
      : this.translateService.instant(
          'attendee.activity_page.organizer_description.showmore'
        );
  }
}
